import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Unpaid from './Unpaid'
import OnlineShop from './OnlineShop'
import Pro from './Pro'
import FourRole from './FourRole'
import styles from './style.module.less'

/** 店铺产品 */
@observer
export default class extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <Unpaid />
        <OnlineShop />
        <Pro />
        <FourRole />
      </div>
    )
  }
}
